'use client';
import { PFText } from './PFText';
import { Suspense, useEffect, useState } from 'react';
import { PFButton } from './PFButton';
import { usePush } from '@/common/usePush';
import { atomWithStorage } from 'jotai/utils';
import PFLink from './PFLink';
import * as stylex from '@stylexjs/stylex';
import { colors } from '@/common/tokens.stylex';

export const pushWidgetClosedAtom = atomWithStorage<boolean>(
  'pushWidgetClosed',
  false,
  undefined,
  {
    getOnInit: true,
  },
);

export function PushNotificationsWidget(props) {
  const { gapBottom } = props;
  const { isPushAviable, askPermission, subscribeButtonOnClick, isSubscribed } =
    usePush(undefined, true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  if (isLoading || !isPushAviable) {
    return null;
  }

  return (
    <Suspense>
      <article {...stylex.props(styles.card, gapBottom && styles.gapBottom)}>
        {!isSubscribed && (
          <>
            <div>
              {props.children}
              <PFText tag="h2" style={styles.heading} size="base">
                Verpasse keine Promiflash-Topnews!
              </PFText>
            </div>
            <PFText style={styles.copy} size="small">
              Melde dich jetzt für Push-Benachrichtigungen an und bleib immer
              auf dem Laufenden.
            </PFText>
            <PFButton
              onClick={(event) => {
                askPermission()
                  .then(() => {
                    subscribeButtonOnClick(event);
                  })
                  .catch((err) => {
                    console.error(err);
                  });
              }}
              variant={'invertedHover'}
            >
              <PFText size="small" style={styles.label}>
                Push aktivieren
              </PFText>
            </PFButton>
            {/* declined button unused */}
          </>
        )}
        {isSubscribed && (
          <>
            <div>
              {props.children}
              <PFText tag="h2" style={styles.heading} size="base">
                Verwalte deine Push Einstellungen
              </PFText>
            </div>
            <PFText style={styles.copy} size="small">
              Bleibe auf dem Laufenden über die aktuellsten Nachrichten aus der
              Welt der Stars.
            </PFText>
            <PFLink href={'/push'}>
              <PFButton asChild variant="invertedHover">
                <PFText size="small" style={styles.label}>
                  Push Einstellungen
                </PFText>
              </PFButton>
            </PFLink>
          </>
        )}
      </article>
    </Suspense>
  );
}

const styles = stylex.create({
  card: {
    width: {
      default: '100%',
      ['@media (min-width: 640px)']: 300,
    },
    backgroundColor: colors.secundaryColor,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    padding: 20,
    textAlign: 'center',
    borderRadius: 12,
    justifyContent: 'center',
  },
  gapBottom: {
    paddingBottom: 48,
  },
  heading: {
    color: colors.white,
    fontWeight: 600,
  },
  copy: {
    color: colors.white,
  },
  label: {
    fontWeight: 400,
  },
});
